import React from "react";

const When = ({ it, children }) => <>{it ? children : null}</>;

export default When;
